module.exports = __webpack_public_path__ + "img/menu.b0ca0f77.svg";